import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { LanguageService } from 'src/app/services/language.service';

@Injectable({
  providedIn: 'root'
})
export class TranslateGuard implements CanActivate {
  constructor(
    private readonly translateService: GoogleTranslateService,
    private readonly languageService: LanguageService,
    private readonly router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    const savedLanguage = this.languageService.getLanguage();
    
    // Initialize Google Translate
    await this.translateService.initGoogleTranslate();

    // Set the language
    await this.translateService.setGoogleTranslateLanguage(savedLanguage);

    // Update notranslate class based on the language
    this.updateNotranslate(savedLanguage);

    return true;
  }

  private updateNotranslate(languageCode: string) {
    if (languageCode === 'en') {
      document.body.classList.add('notranslate');
    } else {
      document.body.classList.remove('notranslate');
    }
  }
}
